export default __webpack_public_path__ + "static/media/high-gloss-600x.af03c7c9.png";